module.exports = {"TXTCLI_Address":{"id":"TXTCLI_Address","defaultMessage":"Адрес (место проживания)","flags":["TRACK"],"track":"Address"}}